(function () {
  if (window.__rbInit) return;
  window.__rbInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.rb-reveal:not(.rb-visible)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('rb-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('rb-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  // Héroe: el producto se inclina siguiendo al ratón
  function initTilt() {
    document.querySelectorAll('[data-rb-tilt]').forEach(function (escena) {
      if (escena.dataset.rbInit) return;
      escena.dataset.rbInit = '1';
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      var foto = escena.querySelector('.rb-heroe__foto');
      var max = parseFloat(escena.dataset.rbTilt) || 8;
      escena.addEventListener('mousemove', function (ev) {
        var r = escena.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        foto.style.setProperty('--ry', (x * max * 2).toFixed(2) + 'deg');
        foto.style.setProperty('--rx', (-y * max * 2).toFixed(2) + 'deg');
      });
      escena.addEventListener('mouseleave', function () {
        foto.style.setProperty('--ry', '0deg');
        foto.style.setProperty('--rx', '0deg');
      });
    });
  }

  // Frase que se ilumina palabra a palabra con el scroll
  var frases = [];
  function initFrases() {
    document.querySelectorAll('[data-rb-frase]').forEach(function (el) {
      if (el.dataset.rbInit) return;
      el.dataset.rbInit = '1';
      var html = el.innerHTML.split(/<br\s*\/?>/i).map(function (linea) {
        return linea.split(/(\s+)/).map(function (w) {
          return /^\s+$/.test(w) || w === '' ? w : '<span class="rb-pal">' + w + '</span>';
        }).join('');
      }).join('<br>');
      el.innerHTML = html;
      frases.push(el);
    });
    actualizarFrases();
  }
  function actualizarFrases() {
    var vh = window.innerHeight;
    frases.forEach(function (el) {
      var pals = el.querySelectorAll('.rb-pal');
      if (reduce) { pals.forEach(function (p) { p.classList.add('rb-on'); }); return; }
      var r = el.getBoundingClientRect();
      var progreso = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      progreso = Math.max(0, Math.min(1, progreso));
      var n = Math.round(progreso * pals.length);
      pals.forEach(function (p, i) { p.classList.toggle('rb-on', i < n); });
    });
  }
  window.addEventListener('scroll', function () { if (frases.length) window.requestAnimationFrame(actualizarFrases); }, { passive: true });

  // Hotspots sobre el producto
  function initHotspots() {
    document.querySelectorAll('[data-rb-hot]').forEach(function (sec) {
      if (sec.dataset.rbInit) return;
      sec.dataset.rbInit = '1';
      var puntos = sec.querySelectorAll('.rb-hot__punto');
      var tarjetas = sec.querySelectorAll('.rb-hot__tarjeta');
      var items = sec.querySelectorAll('.rb-hot__lista li');
      function activar(i) {
        [puntos, tarjetas, items].forEach(function (lista) {
          lista.forEach(function (el, j) { el.classList.toggle('rb-activo', j === i); });
        });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('mouseenter', function () { activar(i); });
        p.addEventListener('click', function () { activar(i); });
        p.addEventListener('focus', function () { activar(i); });
      });
      items.forEach(function (li, i) {
        li.addEventListener('mouseenter', function () { activar(i); });
        li.addEventListener('click', function () { activar(i); });
      });
      if (puntos.length) activar(0);
    });
  }

  // Cifras con cuenta ascendente
  function initContadores() {
    document.querySelectorAll('[data-rb-count]').forEach(function (el) {
      if (el.dataset.rbInit) return;
      el.dataset.rbInit = '1';
      var fin = parseFloat(el.dataset.rbCount) || 0;
      if (reduce || !('IntersectionObserver' in window)) { el.textContent = fin; return; }
      el.textContent = '0';
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var t0 = null, dur = 1400;
        function paso(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / dur);
          var e = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(fin * e);
          if (k < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  // Preguntas frecuentes
  function initFaq() {
    document.querySelectorAll('.rb-faq__preg').forEach(function (btn) {
      if (btn.dataset.rbInit) return;
      btn.dataset.rbInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.rb-faq__item');
        var abierto = item.classList.toggle('rb-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  // Página de producto: galería, variantes y cantidad
  function initProducto() {
    document.querySelectorAll('[data-rb-producto]').forEach(function (sec) {
      if (sec.dataset.rbInit) return;
      sec.dataset.rbInit = '1';
      var principal = sec.querySelector('.rb-prod__principal img');
      sec.querySelectorAll('.rb-prod__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          principal.src = mini.dataset.src;
          principal.alt = mini.dataset.alt || '';
          sec.querySelectorAll('.rb-prod__mini').forEach(function (m) { m.classList.toggle('rb-activo', m === mini); });
        });
      });

      var cant = sec.querySelector('.rb-prod__cant input');
      sec.querySelectorAll('.rb-prod__cant button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          cant.value = Math.max(1, v + parseInt(b.dataset.delta, 10));
        });
      });

      var datos = sec.querySelector('[data-rb-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var selects = sec.querySelectorAll('.rb-prod__opcion select');
      var idInput = sec.querySelector('input[name="id"]');
      var precio = sec.querySelector('.rb-prod__precio-actual');
      var antes = sec.querySelector('.rb-prod__precio-antes');
      var boton = sec.querySelector('[data-rb-boton]');
      var formato = sec.dataset.rbMoneda || '${{amount}}';
      function dinero(cents) {
        var n = (cents / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ',')).replace(/\{\{\s*\w+\s*\}\}/, n);
      }
      selects.forEach(function (s) {
        s.addEventListener('change', function () {
          var valores = Array.prototype.map.call(selects, function (x) { return x.value; });
          var v = variantes.find(function (vr) {
            return vr.options.every(function (o, i) { return o === valores[i]; });
          });
          if (!v) { boton.disabled = true; boton.querySelector('span').textContent = boton.dataset.noDisponible; return; }
          idInput.value = v.id;
          precio.textContent = dinero(v.price);
          if (antes) {
            antes.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
          }
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? boton.dataset.texto : boton.dataset.agotado;
          if (v.featured_image && principal) principal.src = v.featured_image.src;
        });
      });
    });
  }

  function initTodo(ev) {
    var root = ev && ev.target && ev.target.querySelectorAll ? ev.target : document;
    initReveals(root);
    initTilt();
    initFrases();
    initHotspots();
    initContadores();
    initFaq();
    initProducto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
  document.addEventListener('shopify:section:load', initTodo);
})();
